import { Component, OnInit } from '@angular/core';
import { LoaderService } from '../../services/loader.service';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements OnInit {
//#region properties

  //#region private
  //#endregion

  //#endregion

  //#region setters
  //#endregion

  //#region getters
  //#endregion

  //#region ctor
  constructor(public loaderService: LoaderService) { }
  //#endregion

  //#region life cycle hooks
  ngOnInit(): void {
  }
  //#endregion

  //#region public action
  public isVisible() {
    let result = this.loaderService.loaderVisible;
    return result;
  }
  //#endregion

}
